import { ZeltCard } from "./ZeltCard";
import type { Zelt } from "@/data/zelte";

interface ZeltGridProps {
  zelte: Zelt[];
  onNavigate: (path: string) => void;
  onToggleVergleich?: (zelt: Zelt) => void;
  vergleichIds?: string[];
  loading?: boolean;
}

export function ZeltGrid({ zelte, onNavigate, onToggleVergleich, vergleichIds = [], loading = false }: ZeltGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="rounded-lg border bg-card overflow-hidden animate-skeleton"
            style={{ animationDelay: `${i * 100}ms` }}
          >
            <div className="aspect-[4/3] bg-muted" />
            <div className="p-4 space-y-3">
              <div className="h-4 bg-muted rounded w-1/3" />
              <div className="h-6 bg-muted rounded w-3/4" />
              <div className="h-4 bg-muted rounded w-full" />
              <div className="h-4 bg-muted rounded w-2/3" />
              <div className="flex justify-between items-center pt-2">
                <div className="h-6 bg-muted rounded w-20" />
                <div className="h-9 bg-muted rounded w-24" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (zelte.length === 0) {
    return (
      <div className="text-center py-12 animate-fade-in-up">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
          <svg viewBox="0 0 100 100" className="w-8 h-8 text-muted-foreground">
            <polygon points="50,15 85,85 15,85" fill="currentColor" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold mb-2">Keine Zelte gefunden</h3>
        <p className="text-muted-foreground mb-4">Versuchen Sie andere Filtereinstellungen oder den Zelt-Finder.</p>
        <button
          type="button"
          onClick={() => onNavigate("/finder")}
          className="text-primary font-medium hover:underline"
        >
          Zelt-Finder starten
        </button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {zelte.map((zelt, index) => (
        <div
          key={zelt.id}
          className="animate-card-enter"
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <ZeltCard
            zelt={zelt}
            onNavigate={onNavigate}
            onToggleVergleich={onToggleVergleich}
            isInVergleich={vergleichIds.includes(zelt.id)}
          />
        </div>
      ))}
    </div>
  );
}
